module.exports = __webpack_public_path__ + "static/media/1_citrus_cupcake_small.8e81ab63.jpg";